<template>
  <div class="container text-center">
    <p>Jaleko {{ ano }} - Todos os direitos reservados.</p>
    <p>Veja a nossa <a :href="urlPoliticaPrivacidade" target="_blank">política de privacidade</a> e os <a :href="urlTermosUso" target="_blank">termos de uso</a>.</p>
  </div>
</template>

<script>
import DateUtils from '@/core/utils/date-utils'
import { mapState } from 'vuex'

export default {
  name: 'AppFooterB2b',
  data () {
    return {
      ano: DateUtils.formatDate(new Date(), 'YYYY')
    }
  },
  computed: {
    ...mapState({
      configEmpresa: (state) => state.empresa.configEmpresa,
    }),

    urlTermosUso: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}${this.configEmpresa.termoUsoUrl}`
    },

    urlPoliticaPrivacidade: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}documentos/Poli%CC%81tica+de+Privacidade+Jaleko_fev2020Geral_final.pdf`
    }
  }
}
</script>

<style scoped>

</style>
